import {Container} from "reactstrap";
import {useEffect, useState} from "react";
import LogoLarge from "./LogoLarge";

interface Props {
    className?: string;
    logo?: boolean;
    test?: boolean;
}
export default function LoadingPage({className, logo, test}: Props) {
    const [activeIndex, setActiveIndex] = useState(3);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % 4);
        }, 700);
        return () => clearInterval(interval);
    }, []);

    if (test) {
        return null;
    }

    return (
        <Container
            fluid
            className={`${className} w-full flex columns-1 justify-center items-center`}
        >
            {logo && <LogoLarge textClassName={'text-white'}/>}
            <div className="lds-ellipsis w-full">
                <div className={activeIndex > 0 ? 'activate' : 'desactivate'}/>
                <div className={activeIndex > 1 ? 'activate' : 'desactivate'}/>
                <div className={activeIndex > 2 ? 'activate' : 'desactivate'}/>
            </div>
        </Container>
    );
}